import { render, staticRenderFns } from "./BbnwListing.vue?vue&type=template&id=14c21e01&scoped=true&"
import script from "./BbnwListing.vue?vue&type=script&lang=js&"
export * from "./BbnwListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c21e01",
  null
  
)

export default component.exports